const R = require('ramda');
const { failProofAssign } = require('../utils');
const utils = require('../utils/utils');
const DimensionElement = require('./DimensionElement');

/** @type {AdrielCampaign} */
class AdrielCampaign extends DimensionElement {
  constructor(obj) {
    super(obj);
    /** @type {string} The title of the campaign. (Similar to name for channel campaigns)*/
    this.title;
    /** @type {'RUNNING'|'PAUSED'|'DELETED'|'IN_REVIEW'|'DISAPPROVED'|'UNKNOWN'}
     * The status of the campaign.*/
    this.status;
    /** @type {string} unique id for this campaign among all architecture element ids. ex: 'adrielCampaign:123123' */
    this.id;
    /** @type {AdAccountArchitecture} Ad Account Architecture this campaign is part of. */
    this.architecture;
    /** @type {number} Service fee in percentage. ex: 13 -> 13% */
    this.service_fee;
    if (!obj) return;
    obj && failProofAssign(this, obj);
    this.budgetWithType = utils.getBudgetFromAdrielCampaign(this);
  }

  get level() {
    return 'adrielCampaign';
  }

  get objectives() {
    return R.uniq((this.campaigns || []).map(R.prop('objective')));
  }

  get channelBudgets() {
    return this.proposal.budget.channels.filter(channel => channel.value > 0);
  }

  get dailyBudget() {
    return this.proposal.budget.daily;
  }

  get lifeTimeBudget() {
    if (this.isLifeTimeBudget) {
      return this.budgetWithType.value;
    } else return null;
  }

  get isLifeTimeBudget() {
    return this.budgetWithType && this.budgetWithType.type === 'lifeTime';
  }

  get isLeadForm() {
    return R.pathEq(['meta', 'webOrApp', 'type'], 'form', this.proposal);
  }

  get startedDate() {
    const { startDate, asap } = this.proposal.schedule;
    let startedDate = this.started_at;
    if (!asap && startDate > startedDate) startedDate = startDate;
    return startedDate;
  }

  get endDate() {
    if (this.deactivated_at) return this.deactivated_at;
    const { endDate, continuously } = this.proposal.schedule;
    if (continuously) return null;
    return endDate;
  }

  getSchedule() {
    const { continuously, asap } = this.proposal.schedule;
    return {
      continuously,
      asap,
      startDate: this.startedDate,
      endDate: this.endDate,
      deactivatedAt: this.deactivated_at,
    };
  }

  getSubChannelBudget(subChannel) {
    const subChannelBudgetObj = this.proposal.budget.channels.find(channel => channel.name === subChannel);
    if (subChannelBudgetObj) {
      return subChannelBudgetObj.value;
    } else return 0;
  }

  format({ campaignIds = this.campaignIds, dateGroup, parentElementTableId = null } = {}) {
    const obj = super.format({ campaignIds, dateGroup, parentElementTableId });
    obj.active = this.active;
    if (obj.cell) {
      obj.cell.campaignId = this.id;
      obj.cell.status = this.status;
      obj.cell.objectives = this.objectives;
      obj.cell.budget = this.budgetWithType;
      obj.cell.adAccountName = 'ADRIEL_ACCOUNT';
      obj.cell.starts = this.startedDate;
      obj.cell.ends = this.endDate;
    }
    return obj;
  }

  getJSON() {
    const channelCampaignIds = this.campaigns.map(({ id }) => id);
    return {
      ...R.omit(['architecture', 'FEFormat'], this),
      metric: this.metric,
      channelCampaignIds,
      schedule: this.getSchedule(),
    };
  }
}

module.exports = AdrielCampaign;
